import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Typography } from 'foundations-library/components'
import styles from './styles'

type AnimationType = 'disappearing-letters'

/**
 *
 */
export interface AnimatedTypographyType extends React.ComponentProps<typeof Typography> {
    animation?: AnimationType | null;
}

const useStyles = makeStyles(styles)

/**
 *
 */
const AnimatedTypography = ({
    animation = 'disappearing-letters',
    children,
    'data-testid': dataTestId = 'animated-typography',
    ...props
}: AnimatedTypographyType): JSX.Element => {
    const classes = useStyles()
    const text = typeof children === 'string' || typeof children === 'number'
        ? String(children)
        : ''
    const shouldAnimate = animation === 'disappearing-letters' && text.length > 0

    if (!shouldAnimate) {
        return <Typography {...props} data-testid={dataTestId}>{children}</Typography>
    }

    return <Typography {...props} className={classes.root} data-testid={dataTestId}>
        {text.split('').map((letter, index) => <span
            key={`${letter}-${index}`}
            className={`${classes.letter} ${letter === ' ' ? classes.space : ''}`.trim()}
            style={{ animationDelay: `${index * 0.08}s` }}
            data-testid={`${dataTestId}-letter-${index}`}
            aria-hidden='true'
        >
            {letter === ' ' ? '\u00A0' : letter}
        </span>)}
    </Typography>
}

export default AnimatedTypography
